<ul class="grid row">
  <li (click)="backToStep(2)" class="col">
    <div class="img" [style.backgroundImage]="currentBox ? 'url(assets/img/' + currentBox.img + ')' : 'none'">
      <div *ngIf="!currentBox" class="no-pref-image">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </div>

      <span class="state">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </span>
    </div>
    <div class="title">
      <h3 class="tt-3" *ngIf="currentBox">{{ currentBox.label |translate }}</h3>
      <span class="icon-action-replace" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
        </svg>
      </span>
    </div>
    <p class="subtitle">{{ 'need_mapping.storage.inspiration.steps.title_1_short' | translate }}</p>
  </li>

  <li (click)="backToStep(3)" class="col">
    <div class="img" [style.backgroundImage]="currentFront ? 'url(assets/img/' + currentFront.img + ')' : 'none'">
      <div *ngIf="!currentFront" class="no-pref-image">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </div>

      <span class="state">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </span>
    </div>
    <div class="title">
      <h3 class="tt-3" *ngIf="currentFront">{{ currentFront.label }}</h3>
      <span class="icon-action-replace" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
        </svg>
      </span>
    </div>
    <p class="subtitle">{{ 'need_mapping.storage.inspiration.steps.title_2_short' | translate }}</p>
  </li>

  <li (click)="backToStep(4)" class="col">
    <div class="img" [style.backgroundImage]="currentHandles ? 'url(assets/img/' + currentHandles.img + ')' : 'none'">
      <div *ngIf="!currentHandles" class="no-pref-image">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </div>

      <span class="state">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </span>
    </div>
    <div class="title">
      <h3 class="tt-3" *ngIf="currentHandles">{{ currentHandles.label }}</h3>
      <span class="icon-action-replace" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
        </svg>
      </span>
    </div>
    <p class="subtitle">{{ 'need_mapping.storage.inspiration.steps.title_3_short' | translate }}</p>
  </li>

  <li (click)="backToStep(5)" class="col">
    <div
      class="img"
      [class.pictogram]="currentLegs?.img?.endsWith('.svg')"
      [style.backgroundImage]="currentLegs ? 'url(assets/img/' + currentLegs.img + ')' : 'none'">
      <div *ngIf="!currentLegs" class="no-pref-image">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </div>

      <span class="state">
        <span class="text">
          <svg class="icon-action-replace" aria-hidden="true">
            <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
          </svg>
          {{ 'need_mapping.no_choice.img_text' | translate }}
        </span>
      </span>
    </div>
    <div class="title">
      <h3 class="tt-3" *ngIf="currentLegs">{{ currentLegs.label }}</h3>
      <span class="icon-action-replace" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
        </svg>
      </span>
    </div>
    <p class="subtitle">{{ 'need_mapping.storage.inspiration.steps.title_4_short' | translate }}</p>
  </li>
</ul>

@if (this.current.vendor) {
  <div class="next-button-container">
    <ng-casto-button
      class="primary"
      (click)="start()"
      [label]="'need_mapping.cta' | translate"></ng-casto-button>
  </div>
} @else {
  <div class="next-button-container">
    <ng-casto-button
      class="primary"
      (click)="start()"
      [routerLink]="['/cuisine/configuration']"
      [label]="'need_mapping.cta' | translate"></ng-casto-button>
  </div>
}
